var React = require('react');

function IconShoppingbasket (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"icon_shoppingbasket","d":"M35.459,9.015H27.311V1.253a.625.625,0,0,0-.625-.625H11.446a.625.625,0,0,0-.625.625V9.015H2.674a.627.627,0,0,0-.623.578L0,36.834a.625.625,0,0,0,.623.671H37.509a.625.625,0,0,0,.623-.672L36.083,9.593A.628.628,0,0,0,35.459,9.015Zm-8.773,3.961a.571.571,0,1,1-.573.57A.572.572,0,0,1,26.686,12.976ZM12.071,1.879h13.99V9.016H12.071V1.879Zm-.625,11.1a.571.571,0,1,1-.573.57A.572.572,0,0,1,11.446,12.976ZM1.3,36.256l1.955-25.99h7.568v1.578a1.823,1.823,0,1,0,1.25,0V10.266h13.99v1.578a1.823,1.823,0,1,0,1.25,0V10.266H34.88l1.955,25.99Z","transform":"translate(0 -0.628)","fill":"#2a2c2b"}));
}

IconShoppingbasket.defaultProps = {"width":"38.134","height":"36.877","viewBox":"0 0 38.134 36.877"};

module.exports = IconShoppingbasket;

IconShoppingbasket.default = IconShoppingbasket;
